import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useApp() {
    const app = useSelector<RootState, RootState['app']>(({ app }) => app)

    return app
}
